import Vue from "vue";
import VueRouter from "vue-router";
import Store from "../store/index";

import home from "../views/home/Home.vue";
import index from '../views/index.vue';
import contact from '../views/contact/contact.vue';
import about from "../views/about/about.vue";
import article from "../views/article/article.vue";
import kitchen from "../views/kitchen/kitchen.vue";
import news from "../views/news/news.vue";
import product from "../views/product/product.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: index,
    children: [
      {
        path: '/',
        name: '首页',
        component: home,
      },
      {
        path: '/about',
        name: '企业简介',
        component: about,
      },
      {
        path: '/news',
        name: '新闻资讯',
        component: news,
      },
      {
        path: '/newDetail',
        name: '新闻详情',
        component: () => import("../views/news/newDetail.vue"),
      },
      {
        path: '/product',
        name: '系列产品',
        component: product,
      },
      {
        path: '/productDetail',
        name: '产品详情',
        component: () => import("../views/product/detail.vue"),
      },
      {
        path: '/article',
        name: '宣传资料',
        component: article,
      },
      {
        path: '/kitchen',
        name: '伞塔厨房',
        component: kitchen,
      },
      {
        path: '/kitDetail',
        name: '详情',
        component: () => import("../views/kitchen/kitDetail"),
      },
      {
        path: '/contact',
        name: '联系我们',
        component: contact,
      },
    ]
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  from;
  let { navList } = Store.state;
  window.scrollTo(0, 0);
  navList.forEach(ele => {
    if (ele.routeName == to.path) {
      Store.commit('SET_INFO', { code: ele.code, name: ele.name });
      Store.commit('SET_SUBLIST', { subList: ele.children });
    }
  })
  next()
})

export default router;
